(() => {
  const initialized = new WeakSet();

  function start(loader) {
    if (!loader || initialized.has(loader)) return;
    const nextLink = loader.querySelector('[data-cosmos-next]');
    const gridRoot = loader.closest('#ProductGridContainer')?.querySelector('#product-grid');
    const grid = gridRoot?.matches('ul, ol') ? gridRoot : gridRoot?.querySelector('ul, ol');
    if (!nextLink || !grid) {
      finish(loader);
      return;
    }

    initialized.add(loader);
    let loading = false;

    const replayLogo = () => {
      loader.classList.remove('is-loading');
      void loader.offsetWidth;
      loader.classList.add('is-loading');
    };

    const loadNext = async () => {
      if (loading || !nextLink.href) return;
      loading = true;
      replayLogo();
      loader.querySelector('.cosmos-infinite-scroll__status').textContent = 'Cargando más productos…';

      try {
        const response = await fetch(nextLink.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('No se pudo cargar la siguiente página');
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incomingRoot = doc.querySelector('#product-grid');
        const incomingGrid = incomingRoot?.matches('ul, ol') ? incomingRoot : incomingRoot?.querySelector('ul, ol');
        const incomingLoader = doc.querySelector('[data-cosmos-infinite-scroll]');
        if (!incomingGrid) throw new Error('No se encontró la cuadrícula');

        incomingGrid.querySelectorAll(':scope > li').forEach((card) => {
          card.classList.remove('scroll-trigger--offscreen');
          grid.appendChild(document.importNode(card, true));
        });

        const incomingNext = incomingLoader?.querySelector('[data-cosmos-next]');
        if (incomingNext?.href) {
          nextLink.href = incomingNext.href;
          loading = false;
          loader.classList.remove('is-loading');
          loader.querySelector('.cosmos-infinite-scroll__status').textContent = 'Sigue deslizando para ver más productos';
          observer.observe(loader);
        } else {
          finish(loader);
        }
      } catch (error) {
        loading = false;
        loader.classList.remove('is-loading');
        loader.classList.add('has-error');
        const status = loader.querySelector('.cosmos-infinite-scroll__status');
        status.textContent = 'No pudimos cargar más productos. Puedes intentarlo de nuevo.';
        nextLink.hidden = false;
      }
    };

    nextLink.addEventListener('click', (event) => {
      event.preventDefault();
      nextLink.hidden = true;
      loadNext();
    });

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        observer.unobserve(loader);
        loadNext();
      }
    }, { rootMargin: '500px 0px' });

    loader._cosmosObserver = observer;
    observer.observe(loader);
  }

  function finish(loader) {
    loader._cosmosObserver?.disconnect();
    loader.classList.remove('is-loading', 'has-error');
    loader.classList.add('is-complete');
    const status = loader.querySelector('.cosmos-infinite-scroll__status');
    if (status) status.textContent = 'Ya viste todos los productos';
    const next = loader.querySelector('[data-cosmos-next]');
    if (next) next.remove();
  }

  function initialize(root = document) {
    root.querySelectorAll?.('[data-cosmos-infinite-scroll]').forEach(start);
  }

  document.addEventListener('DOMContentLoaded', () => initialize());
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        if (node.matches?.('[data-cosmos-infinite-scroll]')) start(node);
        initialize(node);
      }
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
